module.exports = __webpack_public_path__ + "img/spjgc.42b90324.png";